/** @jsxImportSource @emotion/react */
import DesktopFooter from './desktopFooter';
import MobileFooter from './mobileFooter';
import { links } from './links';
import { SerializedStyles } from '@emotion/react';
import useStyles from './style';

const Footer: React.FC<{
  onSubscribe: (email: string) => Promise<{ status: string }>;
  isMinimal?: boolean;
  css?: SerializedStyles;
  variant?: string;
}> = ({ onSubscribe, isMinimal, variant, ...props }) => {
  const { footerContainer, activateFooterContainer } = useStyles();

  return (
    <footer
      css={variant === 'activate' ? activateFooterContainer : footerContainer}
    >
      <DesktopFooter
        key="desktop-footer"
        links={links}
        onSubscribe={onSubscribe}
        isMinimal={isMinimal}
        variant={variant}
        {...props}
      />
      <MobileFooter
        key="mobile-footer"
        links={links}
        onSubscribe={onSubscribe}
        isMinimal={isMinimal}
        variant={variant}
        {...props}
      />
    </footer>
  );
};

export default Footer;
